import { render, staticRenderFns } from "./PrematchMatch.vue?vue&type=template&id=d84e7bb0&scoped=true&lang=pug"
import script from "./PrematchMatch.vue?vue&type=script&lang=js"
export * from "./PrematchMatch.vue?vue&type=script&lang=js"
import style0 from "./PrematchMatch.vue?vue&type=style&index=0&id=d84e7bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84e7bb0",
  null
  
)

export default component.exports